import React from "react";
import OrganizationProfile from "../organization/profile";
import { ContentBody,ContentHeading} from "../style";
import { SectionContainer,Typography,Row,Col} from "../../ppui";


const ForgotPassword = () => {
  return (
    <>
    <SectionContainer>
      <Row justifyContent="center">
        <Col lg={12} xl={10} xxl={10}>
          <ContentHeading>
            <Typography variant="h5" mb="0">
              Organization Onboarding Form
            </Typography>
          </ContentHeading>
          <Row>
          <Col  xs={12}>
          <ContentBody Padding>  
            <OrganizationProfile />
          </ContentBody>
          </Col>
          </Row>
        </Col>
     </Row>
     </SectionContainer>
    </>
  );
};

export default ForgotPassword;
